import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SerializedStyles } from '@emotion/react';
import Loader from '../loader';

export interface LoadingOverlayProps {
  isLoading: boolean;
  contentCss: SerializedStyles;
  children: React.ReactNode;
}

const LoadingOverlay = ({
  isLoading,
  contentCss,
  children,
}: LoadingOverlayProps): JSX.Element => (
  <>
    <AnimatePresence>
      {isLoading && (
        <motion.div
          key="loading"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Loader absolute />
        </motion.div>
      )}
    </AnimatePresence>
    <motion.div css={contentCss} animate={{ opacity: isLoading ? 0.5 : 1 }}>
      {children}
    </motion.div>
  </>
);

export default LoadingOverlay;
